// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-viewer-popup {
  margin-top: 30px;
}

.file-viewer-popup .popup-children {
  height: 100%;
  max-height: 80vh;
  overflow: scroll;
}

.noting-outer-area {
  border-radius: 16px;
  background: #e9f9e5;
  border: 1px solid rgba(0, 0, 0, 0.1215686275);
  min-height: 800px;
}
.noting-outer-area .noting-note-part {
  background: #f6fff4;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
.noting-outer-area .noting-note-part .notes {
  color: rgba(0, 0, 0, 0.8980392157);
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.noting-outer-area .noting-note-part .note-divider {
  width: 95%;
  border-top: 1px solid #e0e0e0;
}
.noting-outer-area .noting-note-part .note-attachfile {
  color: #0763b8;
}
.noting-outer-area .noting-note-part .note-attachfile .upload-document {
  left: 110px;
  height: 30px;
}
.noting-outer-area .noting-history {
  display: inline-block;
  width: 40%;
  border-top: 1.5px solid rgba(0, 0, 0, 0.5019607843);
}
.noting-outer-area .noting-history + span {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 22.4px;
  color: rgba(0, 0, 0, 0.5019607843);
}

.collapsible_box.noting-collapsible-box {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
  border-bottom: 0.74px solid #e0e0e0;
}
.collapsible_box.noting-collapsible-box:last-child {
  border-bottom: none;
}

.collapsible_box.noting-collapsible-box.pad-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  border-bottom: 0.74px solid #e0e0e0;
}
.collapsible_box.noting-collapsible-box.pad-0:last-child {
  border-bottom: none;
}

.checklist-outer {
  border-radius: 6px;
  border: none;
  background: #fff;
}
.checklist-outer .checklist-heading {
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: #000000;
}
.checklist-outer .checklist-point {
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  color: #000000;
}

.history-track {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #3a7425;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.history-track-line::after {
  position: relative;
  top: 16px;
  left: -13px;
  content: "";
  width: 1.5px;
  height: 100%;
  background-color: #3a7425;
  z-index: -1;
}

.history-border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1607843137);
}

.note-history {
  padding: 0;
  margin: 0;
  font-family: Inter;
}

.note-by-name {
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  color: #3a7425;
}

.note-by-designation {
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 18px;
  color: #3a7425;
}

.note-comment {
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: #000000;
}

.note-date-time {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  color: rgba(0, 0, 0, 0.6);
}

.noting-pageination-step {
  width: 190px;
  height: 55px;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.1215686275);
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
}
.noting-pageination-step .pagination-right-arrow,
.noting-pageination-step .pagination-left-arrow {
  height: 45px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rotate-class {
  transform: rotate(180deg);
}

.noting-heading,
.correspondence-heading {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 38.4px;
  letter-spacing: -0.02em;
}

.noting-collapsible-box input[type=checkbox]:checked + label {
  color: #3a7425 !important;
  font-weight: 600 !important;
  background-color: transparent !important;
}
.noting-collapsible-box input[type=checkbox]:checked + label::after {
  content: "" !important;
  width: 15px !important;
  height: 15px !important;
  border: 2px solid transparent;
  border-bottom: 2px solid #45852e !important;
  border-right: 2px solid #45852e !important;
  transform: rotate(225deg);
  transition: transform 0.4s;
  background-color: transparent !important;
  border-radius: 2px !important;
}
.noting-collapsible-box .noting-collapsible-box-label {
  border-radius: 0px !important;
  font-size: 20px !important;
  color: rgba(0, 0, 0, 0.8) !important;
}
.noting-collapsible-box .noting-collapsible-box-label::after {
  content: "" !important;
  width: 15px !important;
  height: 15px !important;
  border: 2px solid transparent;
  border-bottom: 2px solid !important;
  border-right: 2px solid !important;
  background-color: transparent;
  border-radius: 2px;
  transform: rotate(45deg);
  transition: transform 0.4s;
}

.noting-collapsible-box.plot input[type=checkbox]:checked + label {
  color: #3a7425 !important;
  font-weight: 600 !important;
  background-color: #e4eae3 !important;
}

.col-sm-12.wl-50 .d-flex div {
  width: 48% !important;
}

.collapsible_box .view_checkbox input[type=checkbox] {
  display: unset;
}`, "",{"version":3,"sources":["webpack://./src/features/modules/EstateManagement/Advertisement/CreateAdvertisement/Advertisement.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AACA;EACI,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iBAAA;AAEJ;AAAI;EACI,mBAAA;EACA,kBAAA;EACA,yBAAA;AAER;AAAQ;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAEZ;AAAQ;EACI,UAAA;EACA,6BAAA;AAEZ;AAAQ;EACI,cAAA;AAEZ;AAAY;EACI,WAAA;EACA,YAAA;AAEhB;AAEI;EACI,qBAAA;EACA,UAAA;EACA,mDAAA;AAAR;AACQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;AACZ;;AAIA;EACI,4BAAA;EACA,+BAAA;EACA,mCAAA;AADJ;AAEI;EACI,mBAAA;AAAR;;AAGA;EACI,2BAAA;EACA,8BAAA;EACA,mCAAA;AAAJ;AACI;EACI,mBAAA;AACR;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAAR;;AAGA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AAAR;;AAGA;EACI,oDAAA;AAAJ;;AAEA;EACI,UAAA;EACA,SAAA;EACA,kBAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAGJ;;AADA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAIJ;;AAFA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAKJ;;AAHA;EACI,YAAA;EACA,YAAA;EACA,wDAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAMJ;AAJI;;EAEI,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAMR;;AAHA;EACI,yBAAA;AAMJ;;AAJA;;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAOJ;;AAHQ;EACI,yBAAA;EACA,2BAAA;EACA,wCAAA;AAMZ;AAJY;EACI,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,2CAAA;EACA,0CAAA;EACA,yBAAA;EACA,0BAAA;EACA,wCAAA;EACA,6BAAA;AAMhB;AADI;EACI,6BAAA;EACA,0BAAA;EACA,oCAAA;AAGR;AADQ;EACI,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,kCAAA;EACA,6BAAA;EACA,kBAAA;EACA,wBAAA;EACA,0BAAA;AAGZ;;AAIA;EACI,yBAAA;EACA,2BAAA;EACA,oCAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;EACI,cAAA;AADJ","sourcesContent":[".file-viewer-popup {\n    margin-top: 30px;\n}\n\n.file-viewer-popup .popup-children {\n    height: 100%;\n    max-height: 80vh;\n    overflow: scroll;\n}\n.noting-outer-area {\n    border-radius: 16px;\n    background: #e9f9e5;\n    border: 1px solid #0000001f;\n    min-height: 800px;\n\n    .noting-note-part {\n        background: #f6fff4;\n        border-radius: 8px;\n        border: 1px solid #e0e0e0;\n\n        .notes {\n            color: #000000e5;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 24px;\n        }\n        .note-divider {\n            width: 95%;\n            border-top: 1px solid #e0e0e0;\n        }\n        .note-attachfile {\n            color: #0763b8;\n\n            .upload-document {\n                left: 110px;\n                height: 30px;\n            }\n        }\n    }\n    .noting-history {\n        display: inline-block;\n        width: 40%;\n        border-top: 1.5px solid #00000080;\n        & + span {\n            font-family: Inter;\n            font-size: 14px;\n            font-weight: 600;\n            line-height: 22.4px;\n            color: #00000080;\n        }\n    }\n}\n\n.collapsible_box.noting-collapsible-box {\n    padding-top: 30px !important;\n    padding-bottom: 30px !important;\n    border-bottom: 0.74px solid #e0e0e0;\n    &:last-child {\n        border-bottom: none;\n    }\n}\n.collapsible_box.noting-collapsible-box.pad-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n    border-bottom: 0.74px solid #e0e0e0;\n    &:last-child {\n        border-bottom: none;\n    }\n}\n\n.checklist-outer {\n    border-radius: 6px;\n    border: none;\n    background: #fff;\n\n    .checklist-heading {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 32px;\n        letter-spacing: -0.02em;\n        color: #000000;\n    }\n    .checklist-point {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 25.6px;\n        color: #000000;\n    }\n}\n.history-track {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: #3a7425;\n    font-size: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.history-track-line {\n    &::after {\n        position: relative;\n        top: 16px;\n        left: -13px;\n        content: '';\n        width: 1.5px;\n        height: 100%;\n        background-color: #3a7425;\n        z-index: -1;\n    }\n}\n.history-border-bottom {\n    border-bottom: 1px solid #00000029;\n}\n.note-history {\n    padding: 0;\n    margin: 0;\n    font-family: Inter;\n}\n.note-by-name {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20.8px;\n    color: #3a7425;\n}\n.note-by-designation {\n    font-size: 12px;\n    font-style: italic;\n    font-weight: 400;\n    line-height: 18px;\n    color: #3a7425;\n}\n.note-comment {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22.4px;\n    color: #000000;\n}\n.note-date-time {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 19.6px;\n    color: #00000099;\n}\n.noting-pageination-step {\n    width: 190px;\n    height: 55px;\n    box-shadow: 0px 4px 24px 0px #0000001f;\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 25.6px;\n\n    .pagination-right-arrow,\n    .pagination-left-arrow {\n        height: 45px;\n        background: #f1f1f1;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n}\n.rotate-class {\n    transform: rotate(180deg);\n}\n.noting-heading,\n.correspondence-heading {\n    font-family: Inter;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 38.4px;\n    letter-spacing: -0.02em;\n}\n.noting-collapsible-box {\n    input[type='checkbox'] {\n        &:checked + label {\n            color: #3a7425 !important;\n            font-weight: 600 !important;\n            background-color: transparent !important;\n\n            &::after {\n                content: '' !important;\n                width: 15px !important;\n                height: 15px !important;\n                border: 2px solid transparent;\n                border-bottom: 2px solid #45852e !important ;\n                border-right: 2px solid #45852e !important ;\n                transform: rotate(225deg);\n                transition: transform 0.4s;\n                background-color: transparent !important;\n                border-radius: 2px !important;\n            }\n        }\n    }\n\n    .noting-collapsible-box-label {\n        border-radius: 0px !important;\n        font-size: 20px !important;\n        color: #000000cc !important;\n\n        &::after {\n            content: '' !important;\n            width: 15px !important;\n            height: 15px !important;\n            border: 2px solid transparent;\n            border-bottom: 2px solid !important ;\n            border-right: 2px solid !important ;\n            background-color: transparent;\n            border-radius: 2px;\n            transform: rotate(45deg);\n            transition: transform 0.4s;\n        }\n    }\n}\n\n// for plot master\n\n.noting-collapsible-box.plot input[type='checkbox']:checked + label {\n    color: #3a7425 !important;\n    font-weight: 600 !important;\n    background-color: #e4eae3 !important;\n}\n\n.col-sm-12.wl-50 .d-flex div {\n    width: 48% !important;\n}\n\n.collapsible_box .view_checkbox input[type='checkbox'] {\n    display: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
